import React from "react";
import "./SmallCard.scss";
import Accordion from 'react-bootstrap/Accordion'
import Card from "react-bootstrap/Card";
import Badge from "react-bootstrap/Badge";
import { Link } from "../util/router.js";
// import { RiArrowDropDownLine } from "react-icons/ri";
import Icons from "./Icons.js"
import AccordionToggle from './AccordionToggle'
import AccordionContext from "react-bootstrap/AccordionContext";
// import { FaCoffee } from "react-icons/fa"
// import BigCardModal from "./BigCardModal.js"


function SmallCard(props) {
  console.log("SmallCard has rendered")
  const { coffee: {
    coffeeProductUrl,
    coffeeCountry,
    coffeeRegion,
    growingRegion,
    coffeeCompany,
    tastingNotes,
    coffeeCultivar,
    coffeeType,
    coffeeProcess,
    coffeePrice,
    coffeeBagSize,
    roasterLocation,
    coffeeReviewsNumTotal,
    coffeeRatingTotalAdj,
    coffeeReviewAvg,
    coffeeId,
    coffeeImgUrl,
    }} = props;    
    
  return (
    <AccordionContext.Provider>

  <Card border="white" className="w-100">
    <Link to={`/c/${coffeeId}`}><Card.Img variant="top" src={coffeeImgUrl} alt={coffeeCompany}/></Link>
    {props.rating && <span className="text-center mt-2">{props.rating}</span>}    

    <Card.Body>    
      <Card.Subtitle className="d-flex justify-content-between">
            {coffeeRegion ? 
            <Link to={`/c/${coffeeId}`}>
              {coffeeRegion  && `${coffeeRegion}, `} {coffeeCountry}
            </Link>
            :
            (coffeeType).join(" | ")
            }
          {props.bookmark && <span>{props.bookmark}</span>}
      </Card.Subtitle>

      {(coffeeRatingTotalAdj > 0) ? 
        <Card.Subtitle className="my-1 d-flex justify-content-between">
          <span 
          // className={(coffeeReviewAvg > 3.5 ? "coffee-review-high" : "coffee-review-low")}
          >
          {(coffeeReviewAvg).toFixed(1)}<span className="text-muted"> | {coffeeReviewsNumTotal} reviews</span></span>
        </Card.Subtitle> 
        : 
        <Card.Subtitle className="my-1 text-muted">New</Card.Subtitle>}
          
      <Card.Text className="mb-0"><a href={coffeeProductUrl}>{coffeeCompany}</a></Card.Text>
          
      <hr className="first-break mt-1 mb-2" />

      <span className="d-flex justify-content-between">      
      <Card.Text className="text-nowrap" >{(coffeeType).join(" | ")} <Badge variant="outline-primary">{coffeeCultivar}</Badge></Card.Text>              
      {growingRegion && <span className={`${growingRegion}`}>
        <Icons size='2.4em' name={growingRegion} />
      </span>}
      </span>   

      <hr className="my-1" />

      <Card.Text>${coffeePrice} <span className="text-muted"> | {coffeeBagSize}g ({parseFloat((coffeeBagSize*0.03527396198).toFixed(1))}oz)</span>
      </Card.Text>
      <Accordion>
        <AccordionToggle className="tasting-notes-pointer" as={Card.Text} eventKey="0">
        {tastingNotes}
        </AccordionToggle>
        <Accordion.Collapse eventKey="0">
          <>
          {(coffeeBagSize !== 340) && <Card.Text className="text-muted">${parseFloat(340/coffeeBagSize*coffeePrice).toFixed(2)} | 340g (12oz) </Card.Text>}      
          <Card.Text>{coffeeProcess}</Card.Text>
          <Card.Text>
            <a 
              href={`https://www.google.com/maps/search/?api=1&query=${coffeeCompany}+coffee+${roasterLocation}`}>
                {roasterLocation}
            </a>
          </Card.Text>
          <hr style={{ backgroundColor: '#c5a880', height: '3px', width: '95%'}} />
          </>
        </Accordion.Collapse>
      </Accordion> 
    </Card.Body>
  </Card>
  </AccordionContext.Provider> 

  );
}

export default SmallCard;


// <Card className="text-center w-100">

// <Card.Header>
//   {/* <Link to={`/c/${coffeeId}`}><Avatar src={coffeeImgUrl} alt="Company Name" size="128px" /></Link> */}
//   <Link to={`/c/${coffeeId}`}><Card.Img variant="top" src={coffeeImgUrl} alt={coffeeCompany}/></Link>
//   <Link to={`/c/${coffeeId}`}><Card.Text className="mt-2">{coffeeName}</Card.Text></Link>
//   </Card.Header>

// <Card.Body className="pt-2">
//   <Card.Title>{coffeeRegion}, {coffeeCountry}</Card.Title>
//     <Accordion>
//       <Accordion.Toggle as={Button} variant="light" eventKey="0">
//       <Card.Text>{tastingNotes}</Card.Text>
//       </Accordion.Toggle>
//       <Accordion.Collapse   eventKey="0">
//         <ListGroup className="list-group-flush">
//           <ListGroupItem>{coffeeCultivar}</ListGroupItem>
//           {(coffeeBagSize !== 340) &&<ListGroupItem>${parseFloat(340/coffeeBagSize*coffeePrice).toFixed(2)} | 340g (12oz) </ListGroupItem>}
//           <ListGroupItem>{coffeeProcess}</ListGroupItem>
//           <ListGroupItem>{roasterLocation}</ListGroupItem>
//         </ListGroup>
//       </Accordion.Collapse>
//     </Accordion>
// </Card.Body>

// <ListGroup className="list-group-flush">
//   <a href={`${coffeeProductUrl}`}><ListGroupItem>{coffeeCompany}</ListGroupItem></a>  
//   <ListGroupItem>{(coffeeType).join(" | ")}</ListGroupItem>
//   <ListGroupItem>${coffeePrice} | {coffeeBagSize}g ({parseFloat((coffeeBagSize*0.03527396198).toFixed(1))}oz)</ListGroupItem>
// </ListGroup>

// <Card.Footer>
//   {(coffeeReviewsTotal > 0) && <Card.Text><Badge size="md" variant="success">{(coffeeReviewValueTotalAdjusted/coffeeReviewsTotalAdjusted).toFixed(1)} | {coffeeReviewsTotal} Reviews</Badge></Card.Text>}
//   <Card.Text className="mb-0"><Badge variant="light">{coffeeFlavor.join(' | ')}</Badge></Card.Text>
// </Card.Footer>

// </Card> 



